import {SupportedInvoiceIcons} from "../../../lib/types/types";

export const supportedIcons: SupportedInvoiceIcons[] = ['pi-star-fill', 'pi-thumbs-up-fill', 'pi-exclamation-circle'];
export const supportedColors = ['text-green-600', 'text-red-600', 'text-blue-600', 'text-yellow-600']